import { render, staticRenderFns } from "./AffichageArticle.vue?vue&type=template&id=33e8889e&scoped=true&"
import script from "./AffichageArticle.vue?vue&type=script&lang=ts&"
export * from "./AffichageArticle.vue?vue&type=script&lang=ts&"
import style0 from "./AffichageArticle.vue?vue&type=style&index=0&id=33e8889e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e8889e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow})
